/** @format */

import React, { useState } from "react";

import Tabs from "../components/Tabs";
import Select from "../components/Select";
import Table21 from "../components/Table21";
import Table22 from "../components/Table22";
import Table23 from "../components/Table23";
import Table24 from "../components/Table24";
import ContentTop from "../components/ContentTop";

const StatistikhisobotSahifa = () => {
  const [toggle, setToggle] = useState(1);

  const tabs = [
    { title: "1-Jadval", id: 1, type: "text" },
    { title: "2-Jadval", id: 2, type: "text" },
    { title: "3-Jadval", id: 3, type: "text" },
    { title: "4-Jadval", id: 4, type: "text" },
  ];

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari'>
          <li>Statistik hisobotlar</li>

          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          <Select date='2022' />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div
          className={
            toggle == 1 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table21 />
        </div>

        <div
          className={
            toggle == 2 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table22 />
        </div>

        <div
          className={
            toggle == 3 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table23 />
        </div>

        <div
          className={
            toggle == 4 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table24 />
        </div>
      </div>
    </div>
  );
};

export default StatistikhisobotSahifa;
